/* istanbul ignore file */
import { ContentStatus } from 'src/app/shared/enums/content-status';
import { IVideoMediaDto } from './interfaces/i-video-media-dto';
import { IDynamicData } from './interfaces/i-dynamic-data';
import { ContentType } from 'src/app/content-management/shared/enums/content-type';
import { IRepurposingDetail } from '../models/i-article-repurposing-detail';
import { IAuthor } from '../models/i-author';
import { ICompany } from '../models/i-company';
import { IPerson } from '../models/i-person';
import { ITag } from '../models/i-tag';
import { ITopic } from '../models/i-topic';
import { IContentListDto } from './interfaces/i-content-list-dto';
import { ISingleSponsorContentDto } from './interfaces/i-single-sponsor-content-dto';
import { ISponsoredSection } from './interfaces/i-sponsored-section-dto';
import { IImgMediaDto } from './interfaces/i-img-media-dto';
import { ISurtitle } from '../models/i-surtitle';

export class SingleSponsorContentDto implements ISingleSponsorContentDto {
  public id!: string;
  public cas!: string;
  public contentId!: string;
  public headline!: string;
  public standfirst!: string;
  public body!: string;
  public bodyImages!: IImgMediaDto[];
  public bodyVideos!: IVideoMediaDto[];
  public deliveryTargetCodes: string[];
  public contentLists: IContentListDto[];
  public timezoneIdentifier: string;
  public mainImage: IImgMediaDto;
  public mainVideo: IVideoMediaDto;
  public repurposedFromArticleId: string;
  public overallRepurposingParentId: string;
  public repurposedArticles: IRepurposingDetail[];
  public repurposedFromArticles: IRepurposingDetail[];
  public authors: IAuthor[];
  public relatedCompanies: ICompany[];
  public relatedPeople: IPerson[];
  public surtitles: string[];
  public surtitlesDetailed: ISurtitle[];
  public topics: ITopic[];
  public tags: ITag[];
  public languageCode: string;
  public status!: ContentStatus;
  public lastUpdatedDate!: Date;
  public createdDate!: Date;
  public publishedDate!: Date;
  public presetPublishDate!: Date;
  public dynamicData!: IDynamicData;
  public isSpiked: boolean;
  public displayImageOnWebsite: boolean;
  public restrictToRegisteredUsers: boolean;
  public hideThisArticle: boolean;
  public notForGoogleNewsSitemaps: boolean;
  public notForNewsFeeds: boolean;
  public paywallPremiumContent: boolean;
  public notForCompetitors: boolean;
  public lastUpdatedByUser!: string;
  public sponsoredSection: ISponsoredSection;
  public isPublished: () => boolean;
  public isCurrentLiveVersion: () => boolean;

  constructor({
    id,
    cas,
    contentId,
    headline,
    standfirst,
    body,
    bodyImages,
    bodyVideos,
    deliveryTargetCodes,
    contentLists,
    timezoneIdentifier,
    repurposedFromArticleId,
    overallRepurposingParentId,
    repurposedArticles,
    repurposedFromArticles,
    authors,
    relatedCompanies,
    relatedPeople,
    surtitles,
    surtitlesDetailed,
    topics,
    tags,
    languageCode,
    status,
    lastUpdatedDate,
    lastUpdatedByUser,
    createdDate,
    publishedDate,
    presetPublishDate,
    dynamicData,
    isSpiked,
    restrictToRegisteredUsers,
    hideThisArticle,
    notForGoogleNewsSitemaps,
    notForNewsFeeds,
    paywallPremiumContent,
    notForCompetitors,
    sponsoredSection: sponsoredSection,
  }: ISingleSponsorContentDto) {
    this.id = id;
    this.cas = cas;
    this.contentId = contentId;
    this.headline = headline;
    this.standfirst = standfirst;
    this.body = body;
    this.bodyImages = bodyImages ?? [];
    this.bodyVideos = bodyVideos ?? [];
    this.deliveryTargetCodes = deliveryTargetCodes ?? [];
    this.contentLists = contentLists ?? [];
    this.timezoneIdentifier = timezoneIdentifier;
    this.repurposedFromArticleId = repurposedFromArticleId;
    this.overallRepurposingParentId = overallRepurposingParentId;
    this.repurposedArticles = repurposedArticles ?? [];
    this.repurposedFromArticles = repurposedFromArticles ?? [];
    this.authors = authors ?? [];
    this.relatedCompanies = relatedCompanies ?? [];
    this.relatedPeople = relatedPeople ?? [];
    this.surtitles = surtitles ?? [];
    this.surtitlesDetailed = surtitlesDetailed ?? [];
    this.topics = topics ?? [];
    this.tags = tags ?? [];
    this.languageCode = languageCode;
    this.status = status;
    this.lastUpdatedDate = lastUpdatedDate;
    this.createdDate = createdDate;
    this.publishedDate = publishedDate;
    this.presetPublishDate = presetPublishDate;
    this.dynamicData = { ...dynamicData };
    this.lastUpdatedByUser = lastUpdatedByUser;
    this.isSpiked = isSpiked;
    this.restrictToRegisteredUsers = restrictToRegisteredUsers;
    this.hideThisArticle = hideThisArticle;
    this.notForGoogleNewsSitemaps = notForGoogleNewsSitemaps;
    this.notForNewsFeeds = notForNewsFeeds;
    this.paywallPremiumContent = paywallPremiumContent;
    this.notForCompetitors = notForCompetitors;
    this.sponsoredSection = sponsoredSection;

    this.isPublished = () => this.status === ContentStatus.PUBLISHED;
    this.isCurrentLiveVersion = () =>
      this.id === this.dynamicData?.latestPublishedVersionId;
  }
}
